
import { Select } from 'antd'
import PropTypes from 'prop-types'
import { useEffect, useMemo } from 'react'

import { useFetchPractices, usePractices } from '../../redux/slices/practices'
import AsyncSelect from './AsyncSelect'

export function usePracticeOptions() {
  const fetchPractices = useFetchPractices('all')
  const practices = usePractices()

  useEffect(() => {
    fetchPractices()
  }, [fetchPractices])

  const options = useMemo(
    () => (practices || []).map(p => ({ value: String(p.id), label: p.name })),
    [practices],
  )

  return { practices, fetchPractices, options }
}

export default function PracticeSelect({ value = undefined, onChange = () => {}, width = 280, ...props }) {
  const { practices, fetchPractices, options } = usePracticeOptions()

  // Standalone mode: when value and onChange are provided directly (no Formik)
  if (value !== undefined || onChange) {
    return (
      <Select
        style={{ width, flex: 1 }}
        showSearch
        allowClear
        size="middle"
        optionFilterProp="label"
        placeholder="Select a practice"
        value={value}
        onChange={onChange}
        options={options}
        {...props}
      />
    )
  }

  // Formik mode: delegate to AsyncSelect
  return (
    <AsyncSelect
      style={{ width, flex: 1 }}
      fetchOptions={fetchPractices}
      options={practices}
      showSearch
      allowClear
      size="middle"
      optionFilterProp="children"
      placeholder="Select a practice"
      {...props}
    />
  )
}

PracticeSelect.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  value: PropTypes.string,
  onChange: PropTypes.func,
}
